import {useEffect, useState, useSyncExternalStore} from "react";
import {apiActivity} from "../api/http";
import {common} from "../i18n";

// Not for answers that come straight back: only one that's kept the page waiting.
export const ACTIVITY_DELAY_MS = 300;

// A thin bar along the top of the window while the API is still answering, so a page that's waiting for it (on a cold
// start, the first requests can take seconds) doesn't look finished. Every page, whatever it shows of its own.
export function ApiActivityBar() {
    const busy = useSyncExternalStore(apiActivity.subscribe, apiActivity.busy);
    const [shown, setShown] = useState(false);
    useEffect(() => {
        if (!busy) {
            setShown(false);
            return;
        }
        const timer = setTimeout(() => setShown(true), ACTIVITY_DELAY_MS);
        return () => clearTimeout(timer);
    }, [busy]);
    if (!shown) {
        return null;
    }
    return (
        <div className="api-activity-bar" role="progressbar" aria-label={common.loading}>
            <div className="api-activity-bar-fill"/>
        </div>
    );
}
